import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'nhatroktx_saved';
const SAVED_EVENT = 'nhatroktx_saved_changed';

const getSavedIds = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

const notify = (ids) => {
  window.dispatchEvent(new CustomEvent(SAVED_EVENT, { detail: ids }));
};

export const useSavedProperties = () => {
  const [savedIds, setSavedIds] = useState(getSavedIds);

  // Keep all hook instances in sync (cards, pages, navbar badge)
  useEffect(() => {
    const handler = (e) => setSavedIds(e.detail || getSavedIds());
    window.addEventListener(SAVED_EVENT, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(SAVED_EVENT, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  const toggleSaved = useCallback((id) => {
    const next = getSavedIds().includes(id)
      ? getSavedIds().filter((savedId) => savedId !== id)
      : [...getSavedIds(), id];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setSavedIds(next);
    notify(next);
  }, []);

  const isSaved = useCallback(
    (id) => savedIds.includes(id),
    [savedIds]
  );

  return { savedIds, toggleSaved, isSaved };
};